<form [formGroup]="lipForm">
  @if (showboth || isInputPower100) {
    <div class="grid-row ml28" id="lip">
      <input type="radio" id="LIP-inputpower100-radio" formControlName="Options" (change)="handleChange($event)"
        value='Input power at 100% only' class="radio-dimension custom-radio"><label
        for="LIP-inputpower100-radio"
        class="signifyBookmd ml-10">Input power at 100%
      only</label>
    </div>
  }
  @if (showboth || isInputPower100) {
    <div id="luminaireinputpower_container" class="row slider-container">
      <span class="col-3 label signifyBookmd text-mindim dim-margin ml-434343">Luminaire input
        power at
      100%</span>
      <div class="col-3 curvePadding sliderCss">
      </div>
      <div class="row-new1" id="inputOutput">
        <div class="col-1 minValMargin" id="minInput">
          <span class=" signifyBookmd minValue"> min {{ InputPower100Min }}</span>
        </div>
        <div class="col-1" id="maxInput">
          <span class="signifyBookmd maxValue"> max {{ InputPower100Max }}</span>
        </div>
      </div>
      <div class="row form-group col-3 ml-404040" id="accuracy">
        <input type="text" [(value)]="ngModelval['InputPower100']" id="lip_InputPower100_txtbox"
          (keypress)="numberOnlyWithDec($event)" (input)="textValChanged($event.target.value, 'InputPower100')"
          [ngClass]="{'showingError': inputError['InputPower100']===true,'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
          class="input-text form-control signifyBookmd custom-inputbox textbox-standard mt-14" />
          <p class="label signifyBookmd text-mindim dim-margin ml-5555 mt-44444">W (accuracy
          0.1 Watt)</p>
        </div>
      </div>
    }
    @if (showboth || isInputPower100andDim) {
      <div class="grid-row ml28" id="power">
        <input type="radio" id="LIP-inputpower100dim-radio" (change)="handleChange($event)" formControlName="Options"
          value='Input power at 100% and dim' class="radio-dimension custom-radio"><label
          for="LIP-inputpower100dim-radio"
          class="signifyBookmd ml-10">Input power at 100% and
        dim</label>
      </div>
    }
    @if (showboth || isInputPower100andDim) {
      <div [id]="'luminaireinputpower_container'" class="row slider-container">
        <span class="col-3 label signifyBookmd text-mindim dim-margin ml-434343 mt-121212121">Luminaire
          input power at
        100%</span>
        <div class="col-3 curvePadding sliderCss">
        </div>
        <div class="row-new121" id="inputOutput1">
          <div class="col-1 minValMargin" id="minInput1">
            <span class=" signifyBookmd minValue"> min {{ InputPower100Min }}</span>
          </div>
          <div class="col-1" id="maxInput1">
            <span class="signifyBookmd maxValue"> max {{ InputPower100Max }}</span>
          </div>
        </div>
        @if (showboth || isInputPower100andDim) {
          <div class="row form-group col-3 ml-404040" id="watt">
            <input type="text" [(value)]="ngModelval['InputPower1001']" id="lip_InputPower1001_txtbox"
              (keypress)="numberOnlyWithDec($event)" (input)="textValChanged($event.target.value, 'InputPower1001')"
              [ngClass]="{'showingError': inputError['InputPower1001']===true,'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
              class="input-text form-control signifyBookmd custom-inputbox textbox-standard" />
              <p class="label signifyBookmd text-mindim dim-margin ml-5555 mt-101010">W (accuracy
              0.1 Watt)</p>
            </div>
          }
        </div>
      }
      @if (showboth || isInputPower100andDim) {
        <div [id]="'luminaireinputpower_container'" class="row slider-container">
          <span class="col-3 label signifyBookmd text-mindim dim-margin ml-434343 mt-101010">Luminaire
            input power at<br>
          dim level </span>
          <div class="row-new" id="dimlevel">
            <div class="col-1 minValMargin minMaxText" id="minDim">
              <span class=" signifyBookmd minValue"> min {{ DimLevelMin }}</span>
            </div>
            <div class="col-1 minMaxText" id="maxDim">
              <span class="signifyBookmd maxValue"> max {{ DimLevelMax }}</span>
            </div>
          </div>
          @if (showboth || isInputPower100andDim) {
            <div class="col-3 curvePadding sliderCss pdl-40" id="percent">
              <input type="text" [(value)]="ngModelval['DimLevel']" id="lip_DimLevel_txtbox"
                (keypress)="numberOnly($event)" (input)="textValChanged($event.target.value, 'DimLevel')"
                [ngClass]="{'showingError': inputError['DimLevel']===true,'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd custom-inputbox textbox-standard ml-0000" />
                <p class="ll">%</p>
              </div>
            }
            <div class="row-new111" id="powerDim">
              <div class="col-1 minValMargin" id="minPoerDim">
                <span class=" signifyBookmd minValue"> min {{ InputPowerDimMin }}</span>
              </div>
              <div class="col-1" id="maxPowerDim">
                <span class="signifyBookmd maxValue"> max {{ InputPowerDimMax }}</span>
              </div>
            </div>
            <div class="row form-group col-3 ml-404040" id="powerWatt">
              <input type="tel" [(value)]="ngModelval['InputPowerDim']" id="lip_InputPowerDim_txtbox"
                (keypress)="numberOnlyWithDec($event)" (input)="textValChanged($event.target.value, 'InputPowerDim')"
                [ngClass]="{'showingError': inputError['InputPowerDim']===true,'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd custom-inputbox textbox-standard" />
                <p class="label signifyBookmd text-mindim dim-margin ml-5555 mt-101010">W (accuracy
                0.1 Watt)</p>
              </div>
            </div>
          }
          @if (showboth || isInputPower100andDim) {
            <div [id]="'luminaireinputpower_container'" class="row slider-container mt-454545"
              >
              <span class="col-3 label signifyBookmd text-mindim dim-margin ml-434343">(Recommend
              10%)</span>
              <div class="row form-group col-9"></div>
            </div>
          }
          @if (showboth || isInputPower100andDim) {
            <div class="row note-back-new" id="note">
              <span class="col-12 note-text signifyBookmd note1MarginSpc"><span class="signifyBoldmd">Note:</span> When "Input
              power at 100% and dim" option is
              selected, all three input fields need to be filled with actual data for best
              accuracy.
            </span>
          </div>
        }
      </form>
